export default __webpack_public_path__ + "static/media/curve-logo.7de22a5b.svg";